import { BoxProps } from "@chakra-ui/react";
import { Position } from "geojson";
import { ReactNode } from "react";

import { Scenario, useRasterTypeDescriptions, useScenarioRasters } from "@nens/ldo/api-v1";
import { removeNullUndefined } from "@nens/shared-utils";

import { RastersMap } from "../rasters-map/rasters-map";

interface ScenarioRastersMapProps extends BoxProps {
  scenario: Scenario;
  mapId: string;
  size: "s" | "l";
  extraButtons?: ReactNode[];
}

export function ScenarioRastersMap({
  scenario,
  mapId,
  children,
  ...rest
}: ScenarioRastersMapProps) {
  const rasterResponses = useScenarioRasters(scenario);
  const rasterDescriptions = useRasterTypeDescriptions();

  const rasters = removeNullUndefined(
    rasterResponses.map((rasterResponse) =>
      rasterResponse.isSuccess
        ? {
            rasterType: rasterResponse.data.type,
            raster: rasterResponse.data.raster,
            description: rasterDescriptions[rasterResponse.data.type] ?? "Unknown",
          }
        : null
    )
  );

  const markers: Position[] = scenario.breaches.map((breach) => [breach.lon, breach.lat]);

  return (
    <RastersMap
      rasters={rasters}
      markers={markers}
      mapId={mapId}
      scenarioId={scenario.id}
      {...rest}
    >
      {children}
    </RastersMap>
  );
}
